export default "__VITE_ASSET__z36Is8gP__"